// extracted by mini-css-extract-plugin
export default {"container":"Xq-z","heading":"Yq-z","text":"Zq-z","info":"_q-z","link":"ar-z","fullMaxWidth":"br-z"};